import {MESSAGE} from './errorjapanese'
export class Errormessage {
  errorEmail (value) {
    if (value === 'The email has already been taken.') {
      value = MESSAGE.EMAIL_HAS_ALREADY
      return value
    }
    if (value === 'The representative email has already been taken.') {
      value = MESSAGE.EMAIL_HAS_ALREADY
      return value
    }
    if (value === 'The email field is required.') {
      value = MESSAGE.EMAIL_REQUIRED
      return value
    }
    if (value === 'The email must be a valid email address.') {
      value = MESSAGE.EMAIL_FORMAT
      return value
    }
    if (value === 'The selected email is invalid.') {
      value = 'メールアドレスは登録されていません'
      return value
    }
    if (value === 'email or password is incorrect') {
      value = MESSAGE.EMAIL_OR_PASSWORD
      return value
    }
    if (value === 'The email format is invalid.') {
      value = MESSAGE.EMAIL_FORMAT
      return value
    }
    if (value === 'The representative email format is invalid.') {
      value = MESSAGE.EMAIL_FORMAT
      return value
    }
  }
  errorPassword (value) {
    if (value === 'The password field is required.') {
      value = MESSAGE.PASSWORD_REQUIRED
      return value
    }
    if (value === 'The password format is invalid.') {
      value = MESSAGE.PASSWORD_FORMAT
      return value
    }
    if (value === 'The new password format is invalid.') {
      value = MESSAGE.PASSWORD_FORMAT
      return value
    }
  }
  errorAvatar (value) {
    if (value === 'The avatar must be an image.') {
      value = MESSAGE.AVATAR_FORMAT
      return value
    }
  }
  errorFile (value) {
    if (value === 'this name is not enough condition') {
      value = MESSAGE.FILE_NAME_AVAIABLE
      return value
    }
    if (value === '') {
      value = MESSAGE.FILE_SIZE
      return value
    }
    if (value === '') {
      value = MESSAGE.FILE_NAME
    }
  }
  errorFolder (value) {
    if (value === 'this name is not enough condition') {
      value = MESSAGE.FOLDER_NAME
      return value
    }
  }
}
const errorMessage = new Errormessage()

export default errorMessage



// WEBPACK FOOTER //
// ./src/utils/errormessage.js